import { NgRedux } from '@ptl/angular-redux-store';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PtlNotificationService, PtlNotificationStyle } from '@ptl/global-components';
import { StateStructure } from '@ptl/state';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES, AxwayTokenFetcherService } from '@ptl/xhr';
import { SendOOCRequest, SendOOCResponse, SendOOCStatusResponse } from '../interfaces/send-outline-of-coverage.interface';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class SendOutlineOfCoverageService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private ptlNotificationService: PtlNotificationService,
    protected ngRedux: NgRedux<StateStructure>,
    private commonUtilityService: CommonUtilityService,
    private axwayTokenFetcherService: AxwayTokenFetcherService
  ) { }

  sendOOCEmail(payload: SendOOCRequest): Promise<SendOOCResponse> {
    const env = this.commonUtilityService.getTestEnvironment();
    const requestConfig = new RequestConfigImplementation({
        method: REQUEST_METHODS.POST,
        url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.EMAIL_SERVICES.SEND_EMAIL_EXACTTARGET, {}),
        headers: new HttpHeaders({
          'x-hmhs-test-backend': `wasinter${env}.highmark.com`
        }),
        POST_OR_PUT_PAYLOAD: payload,
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpClient.makeRequest(requestConfig);
  }

  getOOCStatus(referralId: string): Promise<SendOOCStatusResponse> {
    const requestConfig = new RequestConfigImplementation({
        method: REQUEST_METHODS.POST,
        url: '/sxesvc/api/v3/referralApp/retrieveStatus',
        headers: new HttpHeaders({
        }),
        POST_OR_PUT_PAYLOAD: { referralId },
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  showGenericError() {
    this.ptlNotificationService.open({
      title: 'Error',
      content: 'Something went wrong. Please try again later.',
      primaryButtonText: 'OK',
      notificationStyle: PtlNotificationStyle.DANGER
    });
  }
}